import { customization } from '@yola/ws-sdk';
import compilePaletteIfNeeded from './compile-palette-if-needed';

let cachedPalette = null;
let cachedCompiledPalette = null;

const getCompiledCurrentPalette = () => {
  const storedPalette = customization.accessors.getCurrentColorPalette();

  if (cachedPalette === storedPalette && cachedCompiledPalette) {
    return cachedCompiledPalette;
  }

  cachedCompiledPalette = compilePaletteIfNeeded(storedPalette);
  cachedPalette = storedPalette;

  return cachedCompiledPalette;
};

export default getCompiledCurrentPalette;
